// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { currencyMenuStyles } from "@insite/content-library/Widgets/Common/CurrencyMenu";
import { css } from "styled-components";

currencyMenuStyles.currencyWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

currencyMenuStyles.currencySelect = {
    ...currencyMenuStyles.currencySelect,
    cssOverrides: {
        formInputWrapper: css`
            width: 100px;
            #currencyMenu {
                box-shadow: none;
            }
        `,
        inputSelect: css`
            border: none;
            text-transform: uppercase;
        `,
    },
};

currencyMenuStyles.currencySymbol = {
    size: 20,
    color: "common.ui5",
    css: css`
        margin-right: 4px;
    `,
};
